import {reactive, ref} from "vue";
import {defineStore} from "pinia";
import {authGetUser, langGetFormOptions} from "@/services/preloads";
import {IsLocal} from "@/utils/appHelper";

export const useAuthStore = defineStore("auth", () => {
    const userData = ref(null);
    const localeOptions = ref([]);

    const setLangOptions = (data) => {
        localeOptions.value = data;
    };
    const setUserData = (data) => {
        userData.value = data;
    };

    const getLangOptions = async () => {
        const response = await langGetFormOptions();
        setLangOptions(response.data.data);
    };
    const initUserData = async () => {
        if (!localStorage.getItem("token")) return;
        const response = await authGetUser();
        if (!response) return;

        setUserData({
            ...response.data.data,
            permissions: undefined,
        });
        response.data.data.permissions.forEach((permission) => {
            permissions[permission] = true;
        });
    };

    // Языки и пользователь независимы друг от друга, поэтому грузим их
    // параллельно и изолированно: падение одного не должно ломать второй.
    const initApp = async () => {
        const [lang, user] = await Promise.allSettled([
            getLangOptions(),
            initUserData(),
        ]);

        if (lang.status === "rejected")
            console.error("[boot] не удалось загрузить список языков", lang.reason);
        if (user.status === "rejected")
            console.error("[boot] не удалось загрузить пользователя", user.reason);
    };

    const permissions = reactive({});
    const hasPermission = (permission) => {
        if (IsLocal()) {
            return true;
        }
        return !!permissions[permission];
    };

    return {
        userData,
        setUserData,
        initUserData,
        localeOptions,
        setLangOptions,
        getLangOptions,
        initApp,
        hasPermission,
    };
});
